import type { UserInfoResponse, UserResponse } from "@blox/api";

/**
 *  Return the user country from the keycloak user info response
 */
export const selectUserCountry = (data: UserResponse) => data.attributes.countryCode?.[0];

export const selectUserId = (data: UserInfoResponse) => data.sub;
